<template>
    <footer class="main-layout__footer">
        <div class="main-layout__container">
            <div class="main-footer">
                <div class="main-footer__content">
                    <img
                        src="@/assets/icons/logo-small.svg"
                        class="main-footer__logo"
                    />

                    <router-link :to="{ name: 'DocumentsList' }" class="main-footer__link">Документы</router-link>
                </div>

                <a
                    href="#"
                    class="main-footer__link"
                    @click.prevent="openReportModal"
                >Техподдержка</a>
            </div>
        </div>
    </footer>
</template>

<script lang="ts" setup>
    import { inject } from 'vue';
    import { ModalPlugin } from '@/plugins/modalPlugin';

    import ReportModal from '@/modals/ReportModal/ReportModal.vue';

    const $modal = inject('$modal') as typeof ModalPlugin;

    function openReportModal(): void {
        $modal.open({
            component: ReportModal,
        });
    }
</script>
